import React, { useCallback, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { useFormState } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import { doGetQCXRequest } from '../../utils/api/domain/domain-api-utils';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectComponenteFreteAutocomplete({ id, label, name, initialValues, ...restProps }) {
  const [componentesFrete, setComponentesFrete] = useState([]);

  const fetchAll = useCallback(async () => {
    try {
      const response = await doGetQCXRequest(['diduimp', 'componentes-frete']);

      if (response.status < 200 || response.status > 299) {
        throw new Error('status inesperado.');
      }

      setComponentesFrete(response.data);
    } catch (err) {
      setComponentesFrete([{ id: 'Erro', code: '000', description: 'Erro ao listar componentes do frete' }]);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const { values } = useFormState();
  const localInitialValues = useMemo(() => initialValues || values, [initialValues, values]);
  const [defaultValue, setDefaultValue] = useState('');
  useEffect(() => {
    if (!componentesFrete) return;

    const value = componentesFrete.find((item) => {
      const formValue = _.get(localInitialValues, name);

      return item?.id === Number(formValue) || item?.id === formValue?.id;
    });
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [componentesFrete, localInitialValues, name]);

  const getOptionLabel = useCallback((item) => {
    if (!item.code || !item.description) return '';

    return `${item.code} - ${item.description}`;
  }, []);
  const filterOptions = createFilterOptions({ stringify: getOptionLabel });

  return (
    <QCXAutocompleteSelect
      id={id}
      label={label}
      name={name}
      options={componentesFrete}
      filterOptions={filterOptions}
      getOptionLabel={getOptionLabel}
      defaultValue={defaultValue}
      {...restProps}
    />
  );
}
